import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Pedidos1 from '../imagens/LancPedidos/Pedidos1.png';
import Pedidos2 from '../imagens/LancPedidos/Pedidos2.png';
import Pedidos3 from '../imagens/LancPedidos/Pedidos3.png';
import Pedidos4 from '../imagens/LancPedidos/Pedidos4.png';
import Pedidos5 from '../imagens/LancPedidos/Pedidos5.png';
import Pedidos6 from '../imagens/LancPedidos/Pedidos6.png';
import Pedidos7 from '../imagens/LancPedidos/Pedidos7.png';
import Pedidos8 from '../imagens/LancPedidos/Pedidos8.png';


export default class Pedidos extends Component {

  render() {

    const { isOpen, onClose } = this.props;

    return (
      <Modal
        title="Como utilizar a tela de pedidos"
        visible={isOpen}
        className="modal"
        destroyOnClose
        onCancel={onClose}
        footer={null}
        width="50%"
        style={{ top: 10 }}
      >
        <Row>
          <p style={{ fontSize: 18, marginTop: 34 }}>
            Caminho para acessar a funcionalidade:
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Pedidos1} alt="Pedidos 1" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain", paddingBottom: 28 }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <p style={{ fontSize: 18, marginTop: 34 }}>
            A tela de pedidos serve para lojas como restaurantes ou comércios (que fazem pedidos e depois outra pessoa faz o recebimento) poderem gerenciar pedidos de clientes que estejam atualmente consumindo na loja. Aqui o gestor poderá
            gerenciar os pedidos atualmente abertos.
          </p>
          <p style={{ fontSize: 18, marginTop: 18 }}>
            Os pedidos que são exibidos na tela são apenas os que estejam abertos e sejam do dia atual.
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Pedidos2} alt="Pedidos 2" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <p style={{ fontSize: 18, marginTop: 34 }}>
            Existem outras opções extras na tela que podem ser acessadas ao colocar o cursor do mouse sobre o icone no canto superior esquerdo da tela.
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Pedidos3} alt="Pedidos 3" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <p style={{ fontSize: 18, marginTop: 34 }}>
            Para registrar um novo pedido basta clicar no botão "+ novo" preencher o "Nome" e o "Produto" e depois clicar em "Adicionar" e o pedido é criado.
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Pedidos4} alt="Pedidos 4" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <p style={{ fontSize: 18, marginTop: 34 }}>
            Caso você queira alterar um pedido basta clicar no pedido desejado na lista e fazer as suas alterações. Na alteração você poderá adicionar mais itens ao pedido,
            poderá fechar o pedido e clicando na descrição do Produto pode excluir o produto do pedido.
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Pedidos5} alt="Pedidos 4" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain", paddingBottom: 28 }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <p style={{ fontSize: 18, marginTop: 34 }}>
            Ao fechar um pedido o gestor precisa inserir as informações de pagamento. Depois basta clicar no botão de "Pagar".
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Pedidos6} alt="Pedidos 4" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <p style={{ fontSize: 18, marginTop: 34 }}>
            Caso seja necessário excluir a venda do pedido o gestor pode acessar a tela de pedidos pelas opções extras e então excluir o pedido.
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Pedidos7} alt="Pedidos 4" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Pedidos8} alt="Pedidos 4" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

        </Row>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancPedidos.js